import { PRIVATE_BASE_URL, PUBLIC_BASE_URL, GAME_ID } from '@config/game.js'
import { requestAll } from '@helpers/requestAll.js'
import { queryString } from '@helpers/utils.js'
import { createClient } from '@services'
import qs from 'qs'

const { get, post, del } = createClient()

/* API request to get user */
export async function getUserRequest() {
  const { data } = await get(`${PUBLIC_BASE_URL}/me`)
  return data
}

/* API request to update user subscriptions */
export function getMySubscriptionsRequest() {
  const query = { game_id: GAME_ID }
  return requestAll(`${PUBLIC_BASE_URL}/me/subscribed${queryString(query)}`)
}

/* API request to get user's ratings */
export function getAllUserRatings() {
  const query = { game_id: GAME_ID }
  return requestAll(`${PUBLIC_BASE_URL}/me/ratings${queryString(query)}`)
}

/* API request to subscribe to mod */
export function subscribeToModRequest({ gameId, modId } = {}) {
  return post(
    `${PUBLIC_BASE_URL}/games/${gameId}/mods/${modId}/subscribe`,
    qs.stringify({ noop: 'noop' })
  )
}

/* API request to unsubscribe to mod */
export async function unsubscribeToModRequest({ gameId, modId } = {}) {
  const { data } = await del(
    `${PUBLIC_BASE_URL}/games/${gameId}/mods/${modId}/subscribe`
  )
  return data
}

/* API request to update to mod rating */
export function updateModRatingRequest({ gameId, modId, rating } = {}) {
  return post(
    `${PUBLIC_BASE_URL}/games/${gameId}/mods/${modId}/ratings`,
    qs.stringify({ rating })
  )
}

/* API request to subscribe to a user */
export function subscribeToUserRequest(nameId) {
  return post(`${PRIVATE_BASE_URL}/users/@${nameId}/subscribe`, null, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}

/* API request get user details */
export async function getPublicUserRequest(userId) {
  const id = Number.isInteger(userId) ? userId : `@${userId}`

  const { data } = await get(`${PRIVATE_BASE_URL}/users/${id}`)
  return data
}

/* API request get user's followers */
export async function getPublicUserSubscribersRequest(nameId) {
  const { data } = await get(`${PRIVATE_BASE_URL}/users/@${nameId}/subscribers`)
  return data
}

/* API request to unsubscribe from a user */
export function unsubscribeFromUserRequest(nameId) {
  return del(`${PRIVATE_BASE_URL}/users/@${nameId}/unsubscribe`)
}
